export enum ClientOAuthProvider {
  Google = "google",
}

export interface ExternalLinkConfig {
  url: string
  label: string
}

export interface FeedbackConfig {
  description: string
  typeSchema: Record<string, string>
  externalLink: ExternalLinkConfig
}

export interface Brand {
  id: string
  name: string // Backend field: code
  description: string
  logo?: string
  feedbackConfig?: FeedbackConfig
  workspaceCount: number
  createdAt: Date
  updatedAt: Date
}

export interface BrandOAuthProvider {
  id: string
  name: string
  provider: ClientOAuthProvider
  clientId: string
  clientSecretPreview: string // Masked like "abc*****"
  scopes: string[]
  createdAt: Date
  updatedAt: Date
}

// Form data types
export interface BrandEditData {
  name: string
  description: string
}

export interface OAuthProviderEditData {
  name: string
  provider: ClientOAuthProvider
  clientId: string
  clientSecret: string
  scopes: string[]
}
